import { endpoint } from './endpoint';
import fetch from 'isomorphic-unfetch';

export function addNewEvent(data): Promise<any> {
  const url = endpoint + '/v1/tracking-events';
  const init = {
    method: 'post',
    body: JSON.stringify({ ...data }),
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };
  return fetch(url, init).then((res) => res.json());
}
